/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import UiTableRowItem from './UiTableRowItem'

interface UiTableRowsListProps {
    rows: any[]
    decorationId: string
    onRowClick?: (rowData: any) => void
    onRowInteraction?: (rowData: any) => void
    hasRowsSelected?: boolean
}

const UiTableRowsList = (props: UiTableRowsListProps) => {
    if (!props.rows.length) {
        return null
    }

    return (
        <>
            {props.rows.map((row) => (
                <UiTableRowItem
                    key={row.id}
                    row={row}
                    decorationId={props.decorationId}
                    onRowClick={props.onRowClick}
                    onRowInteraction={props.onRowInteraction}
                    hasRowsSelected={props.hasRowsSelected}
                />
            ))}
        </>
    )
}

export default UiTableRowsList
